import ApiService from './ApiService';
import { API_DEPLOYMENT_V2 } from '../core/CcxEnv';
import DbService from '../types/DbService';
import LbService from '../types/LbService';
import { ServiceClassProps } from '../types/Service';
import Jobs from '../types/Jobs';

// constants
const API_URL = API_DEPLOYMENT_V2;

export default class ServiceService extends ApiService {
    /**
     * Get services for a data store
     * @param {string} dataStoreUuid
     */
    static async getAllServices(dataStoreUuid: string): Promise<any> {
        const response = await this.request(
            'GET',
            `data-stores/${dataStoreUuid}/nodes`
        );

        return {
            dbServices: response?.database_nodes?.map(
                (s: ServiceClassProps) => new DbService(s)
            ),
            lbServices: response?.load_balancer_nodes?.map(
                (s: ServiceClassProps) => new LbService(s)
            ),
        };
    }

    /**
     * Get jobs for a data store
     * @param {string} dataStoreUuid
     */
    static async getAllJobs(dataStoreUuid: string): Promise<any> {
        const response = await this.request(
            'GET',
            `data-stores/${dataStoreUuid}/jobs`
        );
        return new Jobs(response);
    }

    /**
     * Get database services for a data store
     * @param {string} dataStoreUuid
     */
    static async getDbServices(dataStoreUuid: string): Promise<DbService[]> {
        const response = await this.request(
            'GET',
            `deployment/${dataStoreUuid}`
        );
        return response?.database_nodes?.map(
            (s: ServiceClassProps) => new DbService(s)
        );
    }

    /**
     * Get load balancer services for a data store
     * @param {string} dataStoreUuid
     */
    static async getLbServices(dataStoreUuid: string): Promise<LbService[]> {
        const response = await this.request(
            'GET',
            `deployment/${dataStoreUuid}`
        );
        return response?.load_balancer_nodes?.map(
            (s: ServiceClassProps) => new LbService(s)
        );
    }

    protected static getApiUrl() {
        return API_URL;
    }
}
